import { useMessageApi } from "../../../../provider/AntdNotification";
import ButtonWrapper from "../../../components/reuseComp/ButtonWrapper";
import { Form, Input, Spin, Switch, InputNumber, Button, Card } from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import UploadFoodImage from "../../../../lib/UploadFoodImage";
import { useTeamDetails, useTeamSave } from "../../../../hooks/api/team/hooks";

interface Props {
  qData: any;
  id?: any;
}

const { TextArea } = Input;

const TeamForm: React.FC<Props> = ({ qData, id }) => {
  const [form] = Form.useForm();
  const message = useMessageApi();
  const navigate = useNavigate();
  const isEditPage = Boolean(id);

  const { mutate: saveTeam, isPending } = useTeamSave({ qData });
  const { data: teamDetails, isLoading } = useTeamDetails(id);

  console.log(teamDetails, "team-details");

  useEffect(() => {
    if (isEditPage && teamDetails?.data) {
      form.setFieldsValue(teamDetails.data);
    }
  }, [isEditPage, teamDetails, form]);

  const handleSave = async () => {
    try {
      const values = await form.validateFields();

      saveTeam(
        { ...values, _id: id },
        {
          onSuccess: () => {
            message.success(
              isEditPage
                ? "Team updated successfully"
                : "Team created successfully",
            );
            navigate(-1);
          },
          onError: () => message.error("Failed to save Team"),
        },
      );
    } catch (err) {
      console.error(err);
    }
  };

  const showSpinner = isEditPage && isLoading;

  return (
    <div>
      <div className="bg-[#F9F9F9] p-3 md:p-6 rounded-2xl shadow-sm mb-6">
        <Spin spinning={showSpinner} tip="Loading Service details...">
          <Form layout="vertical" form={form}>
            {/* BASIC INFO */}
            <Form.Item name="_id" hidden>
              <Input />
            </Form.Item>

            <Form.Item
              label="Name"
              name="name"
              rules={[{ required: true, message: "Please enter name" }]}
            >
              <Input placeholder="Enter name" />
            </Form.Item>
            <Form.Item
              label="Designation"
              name="designation"
              rules={[{ required: true, message: "Please enter designation" }]}
            >
              <Input placeholder="Enter designation" />
            </Form.Item>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <Form.Item label="Profile Image" name="image">
                <UploadFoodImage
                  maxUploadCount={1}
                  isCropTrue={false}
                  bannerAspect={1 / 1}
                  text="Profile Image"
                />
              </Form.Item>

              {/* STATUS + ORDER */}
              <div className="space-y-2">
                <Form.Item
                  label="Status"
                  name="status"
                  valuePropName="checked"
                  rules={[{ required: true, message: "Please select status" }]}
                >
                  <Switch
                    checkedChildren="Active"
                    unCheckedChildren="Inactive"
                  />
                </Form.Item>

                <Form.Item
                  label="Order"
                  name="order"
                  rules={[{ required: true, message: "Please enter order" }]}
                >
                  <InputNumber
                    placeholder="Order"
                    min={0}
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </div>
            </div>
          </Form>
        </Spin>
      </div>

      {/* BUTTONS */}
      <div className="flex justify-start gap-3 mt-7 sticky bottom-5">
        <ButtonWrapper type="primary" onClick={handleSave} loading={isPending}>
          Save
        </ButtonWrapper>
        <ButtonWrapper onClick={() => navigate(-1)}>Cancel</ButtonWrapper>
      </div>
    </div>
  );
};

export default TeamForm;
